import React from "react";
import { Grid } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import CustomTextField from "./CustomTextField";

export type NameTextFieldProps = {
  control: Control<any, any>
  context?: string;
  name?: string;
  xs?: number;
  md?: number;
  lg?: number;
  label?: string;
  isRequired?: boolean,
  isDisabled?:boolean,
  IsEmpty?:boolean,
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  allowSpecialCharacters?: boolean;
  size?: "small" | "medium";
  usePlaceholder?: boolean;
  hideMiddleName?: boolean;
};

const CustomNametField: React.FC<NameTextFieldProps> = ({
  control,
  context = "",
  name,
  xs,
  md,
  lg,
  label,
  isRequired,
  isDisabled,
  IsEmpty,
  onChange,
  onBlur,
  allowSpecialCharacters = true,
  size,
  usePlaceholder = false,
  hideMiddleName = false,
}) => {
  const firstNameLabel = `${label?label:context} First Name`;
  const middleNameLabel = `${label?label:context} Middle Name`;
  const lastNameLabel = `${label?label:context} Last Name`;

  const colSize = hideMiddleName ? 6 : 4;

  const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }
  }

  const handleFieldBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    if (onBlur) {
      onBlur(event);
    }
  }

  if (name) {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState }) => (
          <Grid container spacing={2}>
            <Grid item xs={xs ? xs : 12} md={md ? md : colSize} lg={lg ? lg : colSize}>
              <CustomTextField controllerName={`${field.name}.${context.toLowerCase()}FirstName`} control={control}
                label={usePlaceholder ? undefined : firstNameLabel} placeholder={usePlaceholder ? "First Name" : undefined} isDisabled={isDisabled}  readOnly={isDisabled} isEmpty={IsEmpty} onChange={handleFieldChange} onBlur={handleFieldBlur}
                rules={{
                  ...(isRequired && {
                    required: `${label || context} First Name is required.`,
                    validate: {
                      customValidation: (value: string) => {
                        if (value?.trim() === "") {
                          return `${label || context} First Name is required.`;
                        }
                      }
                    }
                  })
                }}
                size={size}
                allowSpecialCharacters={allowSpecialCharacters}
              />
            </Grid>
            {!hideMiddleName && (
              <Grid item xs={xs ? xs : 12} md={md ? md : colSize} lg={lg ? lg : colSize}>
                <CustomTextField controllerName={`${field.name}.${context.toLowerCase()}MiddleName`} control={control}
                  label={usePlaceholder ? undefined : middleNameLabel} placeholder={usePlaceholder ? "Middle Name" : undefined} isDisabled={isDisabled}  readOnly={isDisabled} isEmpty={IsEmpty} onChange={handleFieldChange} onBlur={handleFieldBlur} 
                  allowSpecialCharacters={allowSpecialCharacters} size={size} />
              </Grid>
            )}
            <Grid item xs={xs ? xs : 12} md={md ? md : colSize} lg={lg ? lg : colSize}>
              <CustomTextField controllerName={`${field.name}.${context.toLowerCase()}LastName`} control={control}
                label={usePlaceholder ? undefined : lastNameLabel} placeholder={usePlaceholder ? "Last Name" : undefined} isDisabled={isDisabled}  readOnly={isDisabled} isEmpty={IsEmpty} onChange={handleFieldChange} onBlur={handleFieldBlur}
                rules={{
                  ...(isRequired && {
                    required: `${label || context} Last Name is required.`,
                    validate: {
                      customValidation: (value: string) => {
                        if (value?.trim() === "") {
                          return `${label || context} Last Name is required.`;
                        }
                      }
                    }
                  })
                }}
                size={size}
                allowSpecialCharacters={allowSpecialCharacters}
              />
            </Grid>
          </Grid>
        )}
      />
    )
  }
  else {
    return (
      <Grid container spacing={2}>
          <Grid item xs={xs ? xs : 12} md={md ? md : colSize} lg={lg ? lg : colSize}>
            <CustomTextField controllerName={context !== "" ? `${context.toLowerCase()}FirstName` : 'firstName'} control={control}
              label={usePlaceholder ? undefined : firstNameLabel} placeholder={usePlaceholder ? "First Name" : undefined} isDisabled={isDisabled} isEmpty={IsEmpty} onChange={handleFieldChange} onBlur={handleFieldBlur}
              rules={{
                ...(isRequired && {
                  required: `${label || context} First Name is required.`,
                  validate: {
                    doesNotContainSpaces: (value: string) =>
                      !/\s/.test(value) || `${label || context} First Name cannot contain spaces.`,
                    customValidation: (value: string) => {
                      if (value?.trim() === "") {
                        return `${label || context} First Name is required.`;
                      }
                    }
                  }
                })
              }}
              size={size}
              allowSpecialCharacters={allowSpecialCharacters}
             />
          </Grid>
          {!hideMiddleName && (
            <Grid item xs={xs ? xs : 12} md={md ? md : colSize} lg={lg ? lg : colSize}>
              <CustomTextField controllerName={context !== "" ? `${context.toLowerCase()}MiddleName` : 'middleName'} control={control}
                label={usePlaceholder ? undefined : middleNameLabel} placeholder={usePlaceholder ? "Middle Name" : undefined} isDisabled={isDisabled} isEmpty={IsEmpty} onChange={handleFieldChange} onBlur={handleFieldBlur}
                allowSpecialCharacters={allowSpecialCharacters} size={size}/>
            </Grid>
          )}
          <Grid item xs={xs ? xs : 12} md={md ? md : colSize} lg={lg ? lg : colSize}>
            <CustomTextField controllerName={context !== "" ? `${context.toLowerCase()}LastName` :  'lastName'} control={control}
              label={usePlaceholder ? undefined : lastNameLabel} placeholder={usePlaceholder ? "Last Name" : undefined} isDisabled={isDisabled} isEmpty={IsEmpty} onChange={handleFieldChange} onBlur={handleFieldBlur}
              rules={{
                ...(isRequired && {
                  required: `${label || context} Last Name is required.`,
                  validate: {
                    doesNotContainSpaces: (value: string) =>
                      !/\s/.test(value) || `${label || context} Last Name cannot contain spaces.`,
                    customValidation: (value: string) => {
                      if (value?.trim() === "") {
                        return `${label || context} Last Name is required.`;
                      }
                    }
                  }
                })
              }}
              size={size}
              allowSpecialCharacters={allowSpecialCharacters}
            />
          </Grid>
      </Grid>
    );
  }
};

export default CustomNametField;